import React from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import { Col, Container, Row, Toast, ToastBody, ToastHeader } from 'reactstrap'

import { connect } from 'react-redux'
import 'react-tabs/style/react-tabs.css'
import '../../src/assets/scss/photoEditor.scss'
import { saveImageData, initialImageData } from '../redux/photoEditor/actions'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import classnames from 'classnames'

import { toast } from 'react-toastify'
import { createPatternFromImageNew } from '../helper/fileHelper'

const FilterSymbol = {
    brightness: '%',
    contrast: '%',
    saturate: '%',
    sepia: '%',
    invert: '%',
}

const FilterType = {
    original: 0,
    chrome: 1,
    fade: 2,
    mono: 3,
    noir: 4,
}

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = { 37: 1, 38: 1, 39: 1, 40: 1 }

function preventDefault(e) {
    e.preventDefault()
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e)
        return false
    }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false
try {
    window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
            get: function () {
                supportsPassive = true
            },
        })
    )
} catch (e) {}

var wheelOpt = supportsPassive ? { passive: false } : false
var wheelEvent =
    'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel'

// call this to Disable
function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false) // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt) // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt) // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false)
}

// call this to Enable
function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false)
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt)
    window.removeEventListener('touchmove', preventDefault, wheelOpt)
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false)
}

document.addEventListener('wheel', (e) => {
    if (e.target.className === 'editor-crop') {
        disableScroll()
    } else {
        enableScroll()
    }
})

const defaultChanges = {
    filter: {},
    filterType: FilterType.original,
    scale: 1,
    rotate: 0,
    bitRotate: 0,
    flipH: false,
    flipV: false,
    isDragging: false,
    offsetX: 304,
    offsetY: 160,
    canMouseX: 0,
    canMouseY: 0,
    mainPosX: null,
    mainPosY: null,
    lastPosX: null,
    lastPosY: null,
    diffX: null,
    diffY: null,
    patternFlipH: false,
    patternFlipV: false,
}

class PhotoEditor extends React.Component {
    constructor(props) {
        super(props)

        this.editorCropSection = React.createRef()
        this.canvasMono = React.createRef()
        this.canvasNoir = React.createRef()
        this.canvasFade = React.createRef()
        this.canvasChrome = React.createRef()
        this.canvasOriginal = React.createRef()
    }

    state = {
        mainImage: '',
        mainImageData: '',
        mainImage64: '',
        changedImage: '',
        ...defaultChanges,
    }

    componentWillMount() {
        let image = this.props.image
        if (this.props.isMaterial) {
            let material = this.props.photoEditorMaterial
            image = material.url
        }

        this.setState((prevState) => {
            return {
                ...prevState,
                // mainImage: "images/kit.jpeg"
                mainImage: image,
            }
        })

        // const img = new Image();
        // img.onload = () => {
        //   const canvas = document.createElement("CANVAS");
        //   canvas.width = img.naturalWidth;
        //   canvas.height = img.naturalHeight;
        //   const ctx = canvas.getContext("2d");
        //   ctx.drawImage(img, 0, 0, 96, 96);
        //   this.setState({
        //     mainImageData: ctx.getImageData(
        //       0,
        //       0,
        //       img.naturalWidth,
        //       img.naturalHeight
        //     ),
        //     mainImage64: canvas.toDataURL("image/png")
        //   });
        // };
        // img.src = "images/kit.jpeg";
    }

    componentDidMount() {
        this.loadImageOnCanvas()
    }

    componentDidUpdate() {
        this.loadImageOnCanvas()
    }

    changeFilterCanvas = () => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'

        img.onload = () => {
            const scaleW = 96 / img.naturalWidth
            const scaleH = 96 / img.naturalHeight
            if (this.canvasOriginal.current) {
                const canvasOriginal = this.canvasOriginal.current
                const originalCtx = canvasOriginal.getContext('2d')
                originalCtx.scale(scaleW, scaleH)
                originalCtx.drawImage(img, 0, 0)
                originalCtx.scale(0, 0)
            }

            if (this.canvasNoir.current) {
                const canvasNoir = this.canvasNoir.current
                const noirCtx = canvasNoir.getContext('2d')
                noirCtx.filter = 'saturate(20%) contrast(150%)'
                noirCtx.scale(scaleW, scaleH)
                noirCtx.drawImage(img, 0, 0)
                noirCtx.scale(0, 0)
            }

            if (this.canvasFade.current) {
                const canvasFade = this.canvasFade.current
                const fadeCtx = canvasFade.getContext('2d')
                fadeCtx.filter = 'saturate(180%) brightness(90%)'
                fadeCtx.scale(scaleW, scaleH)
                fadeCtx.drawImage(img, 0, 0)
                fadeCtx.scale(0, 0)
            }

            if (this.canvasChrome.current) {
                const canvasChrome = this.canvasChrome.current
                const chromeCtx = canvasChrome.getContext('2d')
                chromeCtx.filter = 'saturate(180%) brightness(120%)'
                chromeCtx.scale(scaleW, scaleH)
                chromeCtx.drawImage(img, 0, 0)
                chromeCtx.scale(0, 0)
            }

            if (this.canvasMono.current) {
                const canvasMono = this.canvasMono.current
                const monoCtx = canvasMono.getContext('2d')
                monoCtx.filter = 'saturate(20%) contrast(110%)'
                monoCtx.scale(scaleW, scaleH)
                monoCtx.drawImage(img, 0, 0)
                monoCtx.scale(0, 0)
            }
        }
        img.src = 'images/kit.jpeg'
    }

    getEditorCanvas = (width = 0, height = 0) => {
        const canvas = document.querySelector('#editor-canvas')
        if (width !== 0 && height !== 0) {
            canvas.width = width
            canvas.height = height
        }
        return canvas
    }

    getEditorContext = () => {
        const canvas = document.querySelector('#editor-canvas')
        return canvas.getContext('2d')
    }

    loadImageOnCanvas = () => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'

        img.onload = () => {
            let canvas = null
            let posX = 0,
                posY = 0,
                scaleH = 1,
                scaleV = 1,
                imgWidth = img.width,
                imgHeight = img.height

            let recDiam = Math.sqrt(
                Math.pow(imgWidth, 2) + Math.pow(imgHeight, 2)
            )
            const recDiamW = this.props.isMaterial ? 600 : 1200
            const recDiamH = this.props.isMaterial ? recDiamW : recDiamW * 0.35
            // const recDiamW = 1200
            // const recDiamH = recDiamW * 0.35

            canvas = this.getEditorCanvas(recDiamW, recDiamH)
            const ctx = canvas.getContext('2d')

            if (this.state.mainPosX === null || this.state.mainPosY === null) {
                this.setState({
                    mainPosX: (recDiamW - imgWidth) / 2,
                    mainPosY: Math.abs((recDiamH - imgHeight) / 2),
                })
            }
            posX = this.state.mainPosX
            posY = this.state.mainPosY

            // Dragging
            if (this.state.isDragging) {
                posX = this.state.canMouseX - this.state.diffX
                posY = this.state.canMouseY - this.state.diffY
            }

            // Filter
            const filters = { ...this.state.filter }
            let ctxFilter = ''
            Object.keys(filters).forEach(function eachKey(key) {
                ctxFilter += `${key}(${filters[key]}${FilterSymbol[key]})`
            })
            ctx.filter = ctxFilter

            // Center Postion of Image
            let X = posX + imgWidth / 2,
                Y = posY + imgHeight / 2

            // Rotate
            if (this.state.rotate !== 0) {
                ctx.translate(X, Y)
                ctx.rotate((this.state.rotate * Math.PI) / 180)
                ctx.translate(-X, -Y)
            }

            if (this.state.bitRotate !== 0) {
                ctx.translate(X, Y)
                ctx.rotate((this.state.bitRotate * Math.PI) / 180)
                ctx.translate(-X, -Y)
            }

            // FlipH & FlipV
            if (this.state.flipH) {
                scaleH = -1
                posX = -(imgWidth + posX)
            }
            if (this.state.flipV) {
                scaleV = -1
                posY = -(imgHeight + posY)
            }

            // Scale
            const scale = this.state.scale
            if (this.state.flipH || this.state.flipV) {
                ctx.scale(scaleH * scale, scaleV * scale)
            } else {
                ctx.translate(X, Y)
                ctx.scale(scale, scale)
                ctx.translate(-X, -Y)
            }

            switch (this.state.filterType) {
                case FilterType.chrome:
                    ctx.filter = ctxFilter + ' saturate(180%) brightness(120%)'
                    break
                case FilterType.fade:
                    ctx.filter = ctxFilter + ' saturate(180%) brightness(90%)'
                    break
                case FilterType.mono:
                    ctx.filter = ctxFilter + ' saturate(20%) contrast(110%)'
                    break
                case FilterType.noir:
                    ctx.filter = ctxFilter + ' saturate(20%) contrast(150%)'
                    break
                default:
                    break
            }

            ctx.drawImage(img, posX, posY, imgWidth, imgHeight)
            ctx.rotate(0)
            ctx.scale(1, 1)

            if (this.props.isMaterial) this.drawPattern(ctx)
        }

        img.src = this.state.mainImage
    }

    getCroppedImageCanvas = (ctx) => {
        const tempCanvas = document.createElement('canvas')
        const tempCtx = tempCanvas.getContext('2d')

        const cropSection = this.editorCropSection.current
        let imageData = ctx.getImageData(
            cropSection.offsetLeft + (this.props.isMaterial ? 16 : 0),
            cropSection.offsetTop,
            cropSection.offsetWidth,
            cropSection.offsetHeight
        )
        tempCanvas.width = cropSection.offsetWidth
        tempCanvas.height = cropSection.offsetHeight

        tempCtx.putImageData(imageData, 0, 0)
        return tempCanvas
    }

    drawPattern = (ctx) => {
        let tempCanvas = this.getCroppedImageCanvas(ctx)
        let pattern = tempCanvas.toDataURL('image/png')

        const patternPreview = document.querySelector(
            '.editor-material-preview'
        )

        if (patternPreview) {
            const { patternFlipH, patternFlipV } = this.state
            createPatternFromImageNew(
                pattern,
                100,
                400,
                patternFlipH,
                patternFlipV
            ).then((imgSrc) => {
                patternPreview.style.backgroundImage = `url(${imgSrc})`
            })
        }
    }

    handleFilterImage = (newFilter) => {
        const filter = { ...this.state.filter, ...newFilter }
        this.setState({ filter })
    }

    handleRotateImage = (angle) => {
        let newAngle = 0
        newAngle = this.state.rotate + angle
        if (newAngle > 360) {
            newAngle = newAngle - 360
        }
        this.setState({ rotate: newAngle })
    }

    handleBitRotateImage = (angle) => {
        this.setState({ bitRotate: angle })
    }

    handleScaleImage = (scaleRatio) => {
        this.setState({ scale: this.state.scale + scaleRatio * 0.02 })
    }

    handleFlipHImage = () => {
        this.setState({ flipH: !this.state.flipH })
    }

    handleFlipVImage = () => {
        this.setState({ flipV: !this.state.flipV })
    }

    handlePatternFlipHImage = () => {
        this.setState({ patternFlipH: !this.state.patternFlipH })
    }

    handlePatternFlipVImage = () => {
        this.setState({ patternFlipV: !this.state.patternFlipV })
    }

    handleFixedValueRange = (value, type) => {
        if (type === 'value') {
            return false
            // return value.toFixed(2);
        }
        // return value;
    }

    handleSaveImage = () => {
        const cropSection = this.editorCropSection.current
        const canvas = this.getEditorCanvas()
        var ctx = canvas.getContext('2d')
        let canvas1 = this.getCroppedImageCanvas(ctx)

        // canvas1.toBlob((b) => {
        //     window.open(window.URL.createObjectURL(b))
        // })

        var dataURL = canvas1.toDataURL('image/png')
        return dataURL
    }

    handleMouseDown = (e) => {
        if (e.target.className !== 'editor-crop-section') {
            const canMouseX = parseInt(e.clientX - this.state.offsetX)
            const canMouseY = parseInt(e.clientY - this.state.offsetY)
            console.log('e is down', e)
            console.log('canMouseX', canMouseX)
            console.log('canMouseY', canMouseY)

            this.setState({
                canMouseX,
                canMouseY,
                diffX: canMouseX - this.state.mainPosX,
                diffY: canMouseY - this.state.mainPosY,
                isDragging: true,
            })
        }
    }

    handleMouseUp = (e) => {
        if (e.target.className !== 'editor-crop-section') {
            const canMouseX = parseInt(e.clientX - this.state.offsetX)
            const canMouseY = parseInt(e.clientY - this.state.offsetY)
            console.log('e is up', e)
            console.log('canMouseX', canMouseX)
            console.log('canMouseY', canMouseY)

            this.setState({
                mainPosX: canMouseX - this.state.diffX,
                mainPosY: canMouseY - this.state.diffY,
                canMouseX,
                canMouseY,
                diffX: null,
                diffY: null,
                isDragging: false,
            })
        }
    }

    handleMouseOut = (e) => {
        if (e.target.className !== 'editor-crop-section') {
            const canMouseX = parseInt(e.clientX - this.state.offsetX)
            const canMouseY = parseInt(e.clientY - this.state.offsetY)
            console.log('e is out', e)
            console.log('canMouseX', canMouseX)
            console.log('canMouseY', canMouseY)

            if (this.state.isDragging) {
                this.setState({
                    mainPosX: -100,
                    mainPosY: -100,
                })
            }
            this.setState({
                canMouseX,
                canMouseY,
                isDragging: false,
            })
        }
    }

    degToRad = (angle) => {
        return (angle * Math.PI) / 180
    }

    handleMouseMove = (e) => {
        if (this.state.isDragging) {
            const canMouseX = parseInt(e.clientX - this.state.offsetX)
            const canMouseY = parseInt(e.clientY - this.state.offsetY)

            this.setState({
                canMouseX,
                canMouseY,
            })
        }
    }

    handleFilterType = (type) => {
        this.setState({ filterType: type })
    }

    render() {
        const filterDefault = { brightness: 1, contrast: 1, saturate: 1 }
        const { patternFlipH, patternFlipV } = this.state
        filterDefault.brightness = this.state.filter.brightness
            ? this.state.filter.brightness / 100
            : 1
        filterDefault.contrast = this.state.filter.contrast
            ? this.state.filter.contrast / 100
            : 1
        filterDefault.saturate = this.state.filter.saturate
            ? this.state.filter.saturate / 100
            : 1
        const filterDefaultStr = `brightness(${filterDefault.brightness}) contrast(${filterDefault.contrast}) saturate(${filterDefault.saturate})`

        const cropEditorClassNames = classnames({
            'editor-crop': true,
            'is-material': this.props.isMaterial,
        })

        if (this.props.error) {
            toast(this.props.error)
        }
        return (
            <div className="photo-editor">
                <div className="photo-editor-container">
                    <Tabs
                        className="tab-list"
                        direction={'rtl'}
                        defaultIndex={2}
                        onSelect={(num) => {
                            if (num === 1) {
                                this.changeFilterCanvas()
                            }
                        }}
                    >
                        <div className="photo-editor-menu">
                            <button
                                className="photo-editor-save"
                                onClick={() => {
                                    const file = this.handleSaveImage()
                                    this.props.onUpdate(file, {
                                        patternFlipH,
                                        patternFlipV,
                                    })
                                }}
                            >
                                ذخیره ویرایش
                            </button>
                            <button
                                className="photo-editor-close"
                                onClick={this.props.onClose}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    id="Layer_1"
                                    x="0px"
                                    y="0px"
                                    width="15px"
                                    height="15px"
                                    viewBox="0 0 121.31 122.876"
                                    enableBackground="new 0 0 121.31 122.876"
                                    xmlSpace="preserve"
                                >
                                    <g>
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z"
                                        />
                                    </g>
                                </svg>
                            </button>
                            <button
                                className="photo-editor-refresh"
                                onClick={() => {
                                    this.setState({ ...defaultChanges })
                                }}
                            >
                                <svg
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <g fill="currentColor" fillRule="nonzero">
                                        <path d="M6.036 13.418L4.49 11.872A.938.938 0 1 0 3.163 13.2l2.21 2.209a.938.938 0 0 0 1.326 0l2.209-2.21a.938.938 0 0 0-1.327-1.326l-1.545 1.546zM12 10.216a1 1 0 0 1 2 0V13a1 1 0 0 1-2 0v-2.784z"></path>
                                        <path d="M15.707 14.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 1.414-1.414l2 2z"></path>
                                        <path d="M8.084 19.312a1 1 0 0 1 1.23-1.577 6 6 0 1 0-2.185-3.488 1 1 0 0 1-1.956.412 8 8 0 1 1 2.912 4.653z"></path>
                                    </g>
                                </svg>
                            </button>
                            <div className="photo-editor-utils">
                                <TabList>
                                    <Tab>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M4 1v5.5m0 3.503V23M12 1v10.5m0 3.5v8M20 1v15.5m0 3.5v3M2 7h4M10 12h4M18 17h4"></path>
                                            </g>
                                        </svg>
                                        <span>تنظیم رنگ</span>
                                    </Tab>
                                    <Tab>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M18.347 9.907a6.5 6.5 0 1 0-1.872 3.306M3.26 11.574a6.5 6.5 0 1 0 2.815-1.417"></path>
                                                <path d="M10.15 17.897A6.503 6.503 0 0 0 16.5 23a6.5 6.5 0 1 0-6.183-8.51"></path>
                                            </g>
                                        </svg>

                                        <span>فیلتر</span>
                                    </Tab>
                                    <Tab>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                            >
                                                <path d="M23 17H9a2 2 0 0 1-2-2v-5m0-3V1"></path>
                                                <path d="M1 7h14a2 2 0 0 1 2 2v7m0 4v3"></path>
                                            </g>
                                        </svg>
                                        <span>برش</span>
                                    </Tab>
                                </TabList>
                            </div>
                        </div>
                        <div className="photo-editor-content">
                            <TabPanel>
                                <div className="photo-editor-content-colors">
                                    <Container>
                                        <Row className="h-100">
                                            <Col
                                                sm="10"
                                                md="3"
                                                lg="3"
                                                className="mx-auto d-table h-100"
                                            >
                                                <div className="options-item">
                                                    <InputRange
                                                        maxValue={150}
                                                        minValue={50}
                                                        step={1}
                                                        value={
                                                            this.state.filter &&
                                                            this.state.filter
                                                                .brightness
                                                                ? this.state
                                                                      .filter
                                                                      .brightness
                                                                : 100
                                                        }
                                                        onChange={(value) =>
                                                            this.handleFilterImage(
                                                                {
                                                                    brightness: value,
                                                                }
                                                            )
                                                        }
                                                        formatLabel={
                                                            this
                                                                .handleFixedValueRange
                                                        }
                                                    />
                                                    <p>
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                        >
                                                            <g
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth="3"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                <circle
                                                                    cx="12"
                                                                    cy="12"
                                                                    r="7"
                                                                ></circle>
                                                                <line
                                                                    x1="12"
                                                                    y1="1"
                                                                    x2="12"
                                                                    y2="3"
                                                                ></line>
                                                                <line
                                                                    x1="12"
                                                                    y1="21"
                                                                    x2="12"
                                                                    y2="23"
                                                                ></line>
                                                                <line
                                                                    x1="4.22"
                                                                    y1="4.22"
                                                                    x2="5.64"
                                                                    y2="5.64"
                                                                ></line>
                                                                <line
                                                                    x1="18.36"
                                                                    y1="18.36"
                                                                    x2="19.78"
                                                                    y2="19.78"
                                                                ></line>
                                                                <line
                                                                    x1="1"
                                                                    y1="12"
                                                                    x2="3"
                                                                    y2="12"
                                                                ></line>
                                                                <line
                                                                    x1="21"
                                                                    y1="12"
                                                                    x2="23"
                                                                    y2="12"
                                                                ></line>
                                                                <line
                                                                    x1="4.22"
                                                                    y1="19.78"
                                                                    x2="5.64"
                                                                    y2="18.36"
                                                                ></line>
                                                                <line
                                                                    x1="18.36"
                                                                    y1="5.64"
                                                                    x2="19.78"
                                                                    y2="4.22"
                                                                ></line>
                                                            </g>
                                                        </svg>
                                                        <span>روشنایی</span>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col
                                                sm="10"
                                                md="3"
                                                lg="3"
                                                className="mx-auto d-table h-100"
                                            >
                                                <div className="options-item">
                                                    <InputRange
                                                        maxValue={150}
                                                        minValue={50}
                                                        step={1}
                                                        value={
                                                            this.state.filter &&
                                                            this.state.filter
                                                                .contrast
                                                                ? this.state
                                                                      .filter
                                                                      .contrast
                                                                : 100
                                                        }
                                                        onChange={(value) =>
                                                            this.handleFilterImage(
                                                                {
                                                                    contrast: value,
                                                                }
                                                            )
                                                        }
                                                        formatLabel={
                                                            this
                                                                .handleFixedValueRange
                                                        }
                                                    />
                                                    <p>
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                        >
                                                            <g
                                                                fill="none"
                                                                fillRule="evenodd"
                                                            >
                                                                <circle
                                                                    stroke="currentColor"
                                                                    strokeWidth="3"
                                                                    cx="12"
                                                                    cy="12"
                                                                    r="10"
                                                                ></circle>
                                                                <path
                                                                    d="M12 2v20C6.477 22 2 17.523 2 12S6.477 2 12 2z"
                                                                    fill="currentColor"
                                                                ></path>
                                                            </g>
                                                        </svg>
                                                        <span>کنتراست</span>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col
                                                sm="10"
                                                md="3"
                                                lg="3"
                                                className="mx-auto d-table h-100"
                                            >
                                                <div className="options-item">
                                                    <InputRange
                                                        maxValue={200}
                                                        minValue={0}
                                                        step={3}
                                                        value={
                                                            this.state.filter &&
                                                            this.state.filter
                                                                .saturate
                                                                ? this.state
                                                                      .filter
                                                                      .saturate
                                                                : 100
                                                        }
                                                        onChange={(value) =>
                                                            this.handleFilterImage(
                                                                {
                                                                    saturate: value,
                                                                }
                                                            )
                                                        }
                                                        formatLabel={
                                                            this
                                                                .handleFixedValueRange
                                                        }
                                                    />
                                                    <p>
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                        >
                                                            <g
                                                                fill="none"
                                                                fillRule="evenodd"
                                                            >
                                                                <rect
                                                                    stroke="currentColor"
                                                                    strokeWidth="3"
                                                                    x="2"
                                                                    y="2"
                                                                    width="20"
                                                                    height="20"
                                                                    rx="4"
                                                                ></rect>
                                                                <path
                                                                    d="M20.828 3.172L3.172 20.828A3.987 3.987 0 0 1 2 18V6a4 4 0 0 1 4-4h12c1.105 0 2.105.448 2.828 1.172zM7 7H5v2h2v2h2V9h2V7H9V5H7v2zM12 15h5v2h-5z"
                                                                    fill="currentColor"
                                                                ></path>
                                                            </g>
                                                        </svg>
                                                        <span>ساتوریشن</span>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col
                                                sm="10"
                                                md="3"
                                                lg="3"
                                                className="mx-auto d-table h-100"
                                            >
                                                <div className="options-item">
                                                    <InputRange
                                                        maxValue={100}
                                                        minValue={0}
                                                        step={1}
                                                        value={
                                                            this.state.filter &&
                                                            this.state.filter
                                                                .invert
                                                                ? this.state
                                                                      .filter
                                                                      .invert
                                                                : 0
                                                        }
                                                        onChange={(value) =>
                                                            this.handleFilterImage(
                                                                {
                                                                    invert: value,
                                                                }
                                                            )
                                                        }
                                                        formatLabel={
                                                            this
                                                                .handleFixedValueRange
                                                        }
                                                    />
                                                    <p>
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                        >
                                                            <g
                                                                fill="none"
                                                                fillRule="evenodd"
                                                            >
                                                                <rect
                                                                    stroke="currentColor"
                                                                    strokeWidth="3"
                                                                    x="2"
                                                                    y="2"
                                                                    width="20"
                                                                    height="20"
                                                                    rx="4"
                                                                ></rect>
                                                                <path
                                                                    fill="currentColor"
                                                                    opacity=".3"
                                                                    d="M7 2.5h5v18.75H7z"
                                                                ></path>
                                                                <path
                                                                    fill="currentColor"
                                                                    opacity=".6"
                                                                    d="M12 2.5h5v18.75h-5z"
                                                                ></path>
                                                                <path
                                                                    fill="currentColor"
                                                                    opacity=".9"
                                                                    d="M17 2.5h4v18.75h-4z"
                                                                ></path>
                                                            </g>
                                                        </svg>
                                                        <span>اینورت</span>
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className="photo-editor-scroller">
                                    <ul className="photo-editor-list">
                                        <li
                                            className="photo-editor-tile"
                                            style={{
                                                transform:
                                                    'translate3d(0px, 0px, 0px)',
                                                opacity: 1,
                                            }}
                                        >
                                            <input
                                                id="photo-editor-tile-original"
                                                type="radio"
                                                name="filter"
                                                value="original"
                                                onChange={() =>
                                                    this.handleFilterType(
                                                        FilterType.original
                                                    )
                                                }
                                                checked={
                                                    this.state.filterType ===
                                                    FilterType.original
                                                }
                                            />
                                            <label htmlFor="photo-editor-tile-original">
                                                اصلی
                                            </label>
                                            <div>
                                                <canvas
                                                    ref={this.canvasOriginal}
                                                    width="96"
                                                    height="96"
                                                    style={{
                                                        filter: filterDefaultStr,
                                                    }}
                                                ></canvas>
                                                <div
                                                    style={{
                                                        background:
                                                            'transparent',
                                                    }}
                                                ></div>
                                            </div>
                                        </li>

                                        <li
                                            className="photo-editor-tile"
                                            style={{
                                                transform:
                                                    'translate3d(0px, 0px, 0px)',
                                                opacity: 1,
                                            }}
                                        >
                                            <input
                                                id="photo-editor-tile-chorme"
                                                type="radio"
                                                name="filter"
                                                value="chrome"
                                                onChange={() =>
                                                    this.handleFilterType(
                                                        FilterType.chrome
                                                    )
                                                }
                                                checked={
                                                    this.state.filterType ===
                                                    FilterType.chrome
                                                }
                                            />
                                            <label htmlFor="photo-editor-tile-chrome">
                                                روشن
                                            </label>
                                            <div>
                                                <canvas
                                                    ref={this.canvasChrome}
                                                    width="96"
                                                    height="96"
                                                    style={{
                                                        filter: filterDefaultStr,
                                                    }}
                                                ></canvas>
                                                <div
                                                    style={{
                                                        background:
                                                            'transparent',
                                                    }}
                                                ></div>
                                            </div>
                                        </li>

                                        <li
                                            className="photo-editor-tile"
                                            style={{
                                                transform:
                                                    'translate3d(0px, 0px, 0px)',
                                                opacity: 1,
                                            }}
                                        >
                                            <input
                                                id="photo-editor-tile-fade"
                                                type="radio"
                                                name="filter"
                                                value="fade"
                                                onChange={() =>
                                                    this.handleFilterType(
                                                        FilterType.fade
                                                    )
                                                }
                                                checked={
                                                    this.state.filterType ===
                                                    FilterType.fade
                                                }
                                            />
                                            <label htmlFor="photo-editor-tile-fade">
                                                مات
                                            </label>
                                            <div>
                                                <canvas
                                                    ref={this.canvasFade}
                                                    width="96"
                                                    height="96"
                                                    style={{
                                                        filter: filterDefaultStr,
                                                    }}
                                                ></canvas>
                                                <div
                                                    style={{
                                                        background:
                                                            'transparent',
                                                    }}
                                                ></div>
                                            </div>
                                        </li>

                                        <li
                                            className="photo-editor-tile"
                                            style={{
                                                transform:
                                                    'translate3d(0px, 0px, 0px)',
                                                opacity: 1,
                                            }}
                                        >
                                            <input
                                                id="photo-editor-tile-mono"
                                                type="radio"
                                                name="filter"
                                                value="mono"
                                                onChange={() =>
                                                    this.handleFilterType(
                                                        FilterType.mono
                                                    )
                                                }
                                                checked={
                                                    this.state.filterType ===
                                                    FilterType.mono
                                                }
                                            />
                                            <label htmlFor="photo-editor-tile-mono">
                                                خاکستری
                                            </label>
                                            <div>
                                                <canvas
                                                    ref={this.canvasMono}
                                                    width="96"
                                                    height="96"
                                                    style={{
                                                        filter: filterDefaultStr,
                                                    }}
                                                ></canvas>
                                                <div
                                                    style={{
                                                        background:
                                                            'transparent',
                                                    }}
                                                ></div>
                                            </div>
                                        </li>

                                        <li
                                            className="photo-editor-tile"
                                            style={{
                                                transform:
                                                    'translate3d(0px, 0px, 0px)',
                                                opacity: 1,
                                            }}
                                        >
                                            <input
                                                id="photo-editor-tile-noir"
                                                type="radio"
                                                name="filter"
                                                value="noir"
                                                onChange={() =>
                                                    this.handleFilterType(
                                                        FilterType.noir
                                                    )
                                                }
                                                checked={
                                                    this.state.filterType ===
                                                    FilterType.noir
                                                }
                                            />
                                            <label htmlFor="photo-editor-tile-noir">
                                                سیاه و سفید
                                            </label>
                                            <div>
                                                <canvas
                                                    ref={this.canvasNoir}
                                                    width="96"
                                                    height="96"
                                                    style={{
                                                        filter: filterDefaultStr,
                                                    }}
                                                ></canvas>
                                                <div
                                                    style={{
                                                        background:
                                                            'transparent',
                                                    }}
                                                ></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className="photo-editor-toolbar">
                                    {/* <button
                    className="photo-editor-tool"
                    onClick={() => {
                     
                    }}
                  >
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <g
                        className="doka--icon-aspect-ratio"
                        fill="currentColor"
                        fillRule="evenodd"
                      >
                        <rect
                          x="2"
                          y="4"
                          opacity=".3"
                          width="10"
                          height="18"
                          rx="1"
                          style={{ opacity: 0.3 }}
                        ></rect>
                        <rect
                          opacity=".5"
                          x="4"
                          y="8"
                          width="14"
                          height="14"
                          rx="1"
                          style={{ opacity: 0.85 }}
                        ></rect>
                        <rect
                          x="6"
                          y="12"
                          width="17"
                          height="10"
                          rx="1"
                          style={{ opacity: 0.3 }}
                        ></rect>
                      </g>
                    </svg>
                    <span>Aspect Ratio</span>
                  </button> */}
                                    {this.props.isMaterial && (
                                        <React.Fragment>
                                            <button
                                                className="photo-editor-tool"
                                                onClick={() =>
                                                    this.handlePatternFlipHImage()
                                                }
                                            >
                                                <i className={'material-icons'}>
                                                    flip
                                                </i>
                                                <span>چرخش افقی الگو</span>
                                            </button>
                                            <button
                                                className="photo-editor-tool"
                                                onClick={() =>
                                                    this.handlePatternFlipVImage()
                                                }
                                            >
                                                <i
                                                    className={'material-icons'}
                                                    style={{
                                                        transform:
                                                            'rotate(90deg)',
                                                    }}
                                                >
                                                    flip
                                                </i>

                                                <span>چرخش عمودی الگو</span>
                                            </button>
                                        </React.Fragment>
                                    )}
                                    <button
                                        className="photo-editor-tool"
                                        onClick={() => this.handleFlipVImage()}
                                    >
                                        <svg
                                            width="26"
                                            height="26"
                                            viewBox="0 0 26 26"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g
                                                fill="currentColor"
                                                fillRule="evenodd"
                                            >
                                                <path d="M19.993 12.143H7a1 1 0 0 1-1-1V5.994a1 1 0 0 1 1.368-.93l12.993 5.15a1 1 0 0 1-.368 1.93z"></path>
                                                <path
                                                    d="M19.993 14a1 1 0 0 1 .368 1.93L7.368 21.078A1 1 0 0 1 6 20.148V15a1 1 0 0 1 1-1h12.993z"
                                                    opacity=".6"
                                                ></path>
                                            </g>
                                        </svg>
                                        <span>چرخش افقی</span>
                                    </button>
                                    <button
                                        className="photo-editor-tool"
                                        onClick={() => this.handleFlipHImage()}
                                    >
                                        <svg
                                            width="26"
                                            height="26"
                                            viewBox="0 0 26 26"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g
                                                fill="currentColor"
                                                fillRule="evenodd"
                                            >
                                                <path d="M11.93 7.007V20a1 1 0 0 1-1 1H5.78a1 1 0 0 1-.93-1.368l5.15-12.993a1 1 0 0 1 1.929.368z"></path>
                                                <path
                                                    d="M14 7.007V20a1 1 0 0 0 1 1h5.149a1 1 0 0 0 .93-1.368l-5.15-12.993A1 1 0 0 0 14 7.007z"
                                                    opacity=".6"
                                                ></path>
                                            </g>
                                        </svg>
                                        <span>چرخش عمودی</span>
                                    </button>
                                    <button
                                        className="photo-editor-tool"
                                        onClick={() =>
                                            this.handleRotateImage(90)
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            version="1.1"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="2 1.5587867078413469 22 24.441213292158654"
                                            width="24"
                                            height="24"
                                        >
                                            <defs>
                                                <path
                                                    d="M10 13C9.33 13 9 13.33 9 14C9 18.8 9 21.47 9 22C9 22.67 9.33 23 10 23C16 23 19.33 23 20 23C20.67 23 21 22.67 21 22C21 17.2 21 14.53 21 14C21 13.33 20.67 13 20 13C14 13 10.67 13 10 13Z"
                                                    id="b1bQEUWgFA"
                                                />
                                                <path
                                                    d="M10 7C7.24 7 5 9.24 5 12C5 12.55 4.55 13 4 13C3.45 13 3 12.55 3 12C3 8.13 6.13 5 10 5C10.09 5 10.55 5 11.37 5C10.93 4.55 10.68 4.3 10.63 4.25C10.24 3.86 10.26 3.22 10.65 2.84C11.04 2.46 11.65 2.47 12.04 2.84C12.28 3.08 14.16 4.96 14.4 5.19C14.79 5.58 14.79 6.22 14.4 6.61C14.4 6.61 14.4 6.61 14.4 6.61C14.16 6.84 12.28 8.73 12.04 8.96C11.65 9.35 11.02 9.35 10.63 8.96C10.24 8.57 10.24 7.94 10.63 7.55C10.66 7.51 10.85 7.33 11.18 7C10.47 7 10.08 7 10 7Z"
                                                    id="b1nOzuSq4r"
                                                />
                                            </defs>
                                            <g>
                                                <g>
                                                    <use
                                                        xlinkHref="#b1bQEUWgFA"
                                                        opacity="1"
                                                        fill="#000000"
                                                        fillOpacity="1"
                                                    />
                                                    <g>
                                                        <use
                                                            xlinkHref="#b1bQEUWgFA"
                                                            opacity="1"
                                                            fillOpacity="0"
                                                            stroke="#000000"
                                                            strokeWidth="1"
                                                            strokeOpacity="0"
                                                        />
                                                    </g>
                                                </g>
                                                <g>
                                                    <use
                                                        xlinkHref="#b1nOzuSq4r"
                                                        opacity="1"
                                                        fill="#000000"
                                                        fillOpacity="1"
                                                    />
                                                    <g>
                                                        <use
                                                            xlinkHref="#b1nOzuSq4r"
                                                            opacity="1"
                                                            fillOpacity="0"
                                                            stroke="#000000"
                                                            strokeWidth="1"
                                                            strokeOpacity="0"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>چرخش به راست</span>
                                    </button>
                                    <button
                                        className="photo-editor-tool"
                                        onClick={() =>
                                            this.handleRotateImage(-90)
                                        }
                                    >
                                        <svg
                                            width="26"
                                            height="26"
                                            viewBox="0 0 26 26"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g
                                                transform="translate(3 2)"
                                                fill="currentColor"
                                                fillRule="evenodd"
                                                className="doka--icon-turn"
                                            >
                                                <rect
                                                    y="11"
                                                    width="12"
                                                    height="10"
                                                    rx="1"
                                                ></rect>
                                                <path
                                                    d="M9.823 5H11a5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7H9.626l.747-.747A1 1 0 0 0 8.958.84L6.603 3.194a1 1 0 0 0 0 1.415l2.355 2.355a1 1 0 0 0 1.415-1.414L9.823 5z"
                                                    fillRule="nonzero"
                                                ></path>
                                            </g>
                                        </svg>
                                        <span>چرخش به چپ</span>
                                    </button>
                                </div>
                                <div
                                    style={{
                                        padding: '5px 10px',
                                        background: '#f6f6f6',
                                    }}
                                >
                                    <InputRange
                                        maxValue={45}
                                        minValue={-45}
                                        step={0.01}
                                        value={this.state.bitRotate}
                                        onChange={(value) =>
                                            this.handleBitRotateImage(value)
                                        }
                                        formatLabel={this.handleFixedValueRange}
                                    />
                                </div>
                            </TabPanel>
                            {this.props.isMaterial ? (
                                <Container>
                                    <Row>
                                        <Col
                                            md="6"
                                            className={`editor-result is-material ${
                                                this.props.loading
                                                    ? 'loading'
                                                    : ''
                                            }`}
                                            onWheel={(e) => {
                                                e.persist()
                                                if (e.deltaY < 0) {
                                                    this.handleScaleImage(1)
                                                } else if (e.deltaY > 0) {
                                                    this.handleScaleImage(-1)
                                                }
                                                return false
                                            }}
                                        >
                                            <canvas
                                                id="editor-canvas"
                                                className="mx-auto d-table"
                                            ></canvas>
                                            <div
                                                className={cropEditorClassNames}
                                                onMouseDown={(e) =>
                                                    this.handleMouseDown(e)
                                                }
                                                onMouseMove={(e) =>
                                                    this.handleMouseMove(e)
                                                }
                                                onMouseUp={(e) =>
                                                    this.handleMouseUp(e)
                                                }
                                                onMouseOut={(e) =>
                                                    this.handleMouseOut(e)
                                                }
                                            >
                                                <div
                                                    className="editor-crop-section"
                                                    ref={this.editorCropSection}
                                                ></div>
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="editor-material-preview"></div>
                                        </Col>
                                    </Row>
                                </Container>
                            ) : (
                                <div
                                    className={`editor-result ${
                                        this.props.loading ? 'loading' : ''
                                    }`}
                                    onWheel={(e) => {
                                        e.persist()
                                        if (e.deltaY < 0) {
                                            this.handleScaleImage(1)
                                        } else if (e.deltaY > 0) {
                                            this.handleScaleImage(-1)
                                        }
                                        return false
                                    }}
                                >
                                    <canvas
                                        id="editor-canvas"
                                        className="mx-auto d-table"
                                    ></canvas>
                                    <div
                                        className={cropEditorClassNames}
                                        onMouseDown={(e) =>
                                            this.handleMouseDown(e)
                                        }
                                        onMouseMove={(e) =>
                                            this.handleMouseMove(e)
                                        }
                                        onMouseUp={(e) => this.handleMouseUp(e)}
                                        onMouseOut={(e) =>
                                            this.handleMouseOut(e)
                                        }
                                    >
                                        <div
                                            className="editor-crop-section"
                                            ref={this.editorCropSection}
                                        ></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Tabs>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        loading: store.photoEditor.loading,
        mainImage: store.photoEditor.mainImage,
        changedImage: store.photoEditor.changedImage,
        photoEditorMaterial: store.tools.photoEditorMaterial,
        error: store.photoEditor.error,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveImageData: (image) => {
            dispatch(saveImageData(image))
        },
        initialImageData: (image) => {
            dispatch(initialImageData(image))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoEditor)
